function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifyingglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.51 10.847a5.625 5.625 0 11-11.248 0 5.625 5.625 0 0111.249 0zm5.03 10.655a.75.75 0 01-1.06 0l-4.052-4.052a8.636 8.636 0 111.06-1.06l4.053 4.051a.75.75 0 010 1.06zm-10.654-3.53a7.125 7.125 0 10-7.125-7.126 7.133 7.133 0 007.125 7.125z",
    fill: props.fill
  }));
}

export default SvgMagnifyingglass;